define('models/calendar/session/exercise/exercise',[
    'underscore', 'backbone',
    // src
    'utils',
    'services/api',
    // collections
    'collections/calendar/session/exercise/weight/weeks',
    'collections/calendar/session/exercise/cardio/phase-weeks',
    'collections/calendar/session/exercise/cardio/phases',
], function(
    _, Backbone, U, API,
    // collections
    CWeightWeeks,
    CPhaseWeeks,
    CPhases
) {

    var MExercise = Backbone.Epoxy.Model.extend({
        idAttribute: "_id",
        blacklist: ["index", "_animation", "_id", "next", "oldCid"],
        defaults: {
            // name: "", // blacklisted
            hideTCNotes: false,
            linkNext: false,
            notes: "",
            type: "weight",
        },

        computeds: {
            displayIndex: {
                deps: ["index"],
                get: function(index) {
                    return index + 1;
                }
            },
            name: function() {
                return this.getAnimation() ? this.getAnimation().name : "calendar:Exercise";
            },
            showTCNotes: {
                deps: ["hideTCNotes"],
                get: function(hideTCNotes) {
                    return !hideTCNotes;
                },
                set: function(showTCNotes) {
                    return { hideTCNotes: !showTCNotes };
                },
            },
            animationThumbnail: {
                deps: ["_animation"],
                get: function(animation) {
                    return animation ? animation.thumbnail : "";
                },
            },
        },

        initialize: function(attrs, options) {
            if (this.isWeight()) {
                this._initWeight(this.attributes, options);
            } else if (this.isCardio()) {
                this._initCardio(this.attributes, options);
            }

        },

        _initWeight: function(attrs, options) {
            _.defaults(attrs, this.constructor.defaults.getWeight());

            var weeksCollection = new CWeightWeeks(null, { multiEnabled: attrs.multiEnabled }),
                weeks = attrs.weeks;
            weeksCollection.reset(weeks instanceof Backbone.Collection ? weeks.models : weeks);
            attrs.weeks = weeksCollection;
        },

        _initCardio: function(attrs, options) {
            _.defaults(attrs, this.constructor.defaults.getCardio());

            var phasesCollection = new CPhases(),
                phases = attrs.phases;
            phasesCollection.reset(phases instanceof Backbone.Collection ? phases.models : phases);
            attrs.phases = phasesCollection;
        },

        ///////////////
        // accessors //
        ///////////////
        getAnimation: function() {
            return this.get('_animation');
        },
        getAnimationId: function() {
            return this.get('animatedExercise');
        },

        isCardio: function() {
            return this.getType() === "cardio";
        },

        isWeight: function() {
            return this.getType() === "weight";
        },

        getLinkNext: function() {
            return this.get('linkNext');
        },

        getType: function() {
            return this.get('type');
        },

        getPhases: function() {
            return this.get('phases');
        },

        getWeeks: function() {
            return this.get('weeks');
        },

        getWeeksWithoutIndex: function(weekIndex) {
            var weeks = this.getWeeks().filter(function(week, index) {
                return index !== weekIndex;
            });
            return weeks;
        },

        getCollection: function() {
            if (this.isWeight()) {
                return this.getWeeks();
            } else {
                return this.getPhases();
            }
        },

        getCollectionConstructor: function() {
            if (this.isWeight()) {
                return CWeightWeeks;
            } else {
                return CPhases;
            }
        },

        getWeeksCollection: function(weekIndex) {
            if (this.isWeight()) {
                return this.getWeeks();
            } else {
                var phaseWeeks = new CPhaseWeeks();
                this.getPhases().each(function(model) {
                    phaseWeeks.add(model.getWeek(weekIndex));
                });
                return phaseWeeks;
            }
        },

        getWeek: function(weekIndex) {
            if (this.isWeight()) {
                return this.getWeeks().at(weekIndex);
            } else {
                return this.getPhases().at(weekIndex);
            }
        },

        setWeekDone: function(weekIndex, value) {
            if (this.isWeight()) {
                this.getWeek(weekIndex).set('done', value);
            } else {
                this.setCardioWeekDone(weekIndex, value);
            }
        },

        getWeekDone: function(weekIndex) {
            if (this.isWeight()) {
                var week = this.getWeek(weekIndex);
                return week ? week.isDone() : false;
            } else {
                return this.get('weekDone')[weekIndex];
            }
        },

        setCardioWeekDone: function(weekIndex, value) {
            var weekDone = _.clone(this.get('weekDone')), // https://stackoverflow.com/questions/9909799/backbone-js-change-not-firing-on-model-change
                currentDone = weekDone[weekIndex];

            weekDone[weekIndex] = typeof value !== "undefined" ? value : !currentDone;
            return this.set('weekDone', weekDone);
        },

        hasLoadData: function() {
            var weekHasLoadValue = false;

            this.getWeeksCollection().some(function(week) {
                week.getSets().some(function(set) {
                    weekHasLoadValue = set.hasLoadValue();
                    return weekHasLoadValue;
                });
                return weekHasLoadValue;
            });

            return weekHasLoadValue;
        },

        hasLoadEnabled: function() {
            return this.get('loadEnabled');
        },

        hasMultiRep: function() {
            return this.get('multiEnabled');
        },

        hasNotes: function() {
            var animation = this.getAnimation();
            return this.get('notes') ||
                animation && animation.description;
        },

        toggleLink: function(val, options) {
            return this.set({
                linkNext: _.isUndefined(val) ? this.get('linkNext') : Boolean(val),
            }, options);
        },

        /////////////
        // actions //
        /////////////
        toJSON: function(options) {
            options = options || {};
            var copy = MExercise.__super__.toJSON.call(this, options);

            // call toJSON on the weeks collection
            if (_.has(copy, "weeks")) {
                copy.weeks = copy.weeks.toJSON(options);
            }

            if (_.has(copy, "phases")) {
                copy.phases = copy.phases.toJSON(options);
            }

            return copy;
        },

        toggleLoad: function(val, options) {
            if (this.isWeight()) {
                this.set({
                    loadEnabled: _.isUndefined(val) ? !this.get('loadEnabled') : Boolean(val)
                }, options);
            }
        },

        toggleMultiReps: function(val, options) {
            if (this.isWeight()) {
                this.set({
                    multiEnabled: _.isUndefined(val) ? !this.hasMultiRep() : Boolean(val)
                }, options);
                this.getWeeks().toggleMultiReps(this.hasMultiRep(), options);

            }
        },

        applyFirstWeek: function() {
            var weeks = this.getWeeks();
            weeks.applyWeek(weeks.first(), 1);

        },

        convertToWeight: function(attrs, options) {
            var oldAttrs = _.omit(this.attributes, [
                    "weekDone",
                    "phases",
                    "effort"
                ]),
                newAttrs = _.extend(oldAttrs, _.pick(attrs, [
                    "repsType",
                    "loadEnabled",
                    "multiEnabled",
                    "weeks",
                ]));

            this._initWeight(newAttrs, options);

            this.reset(newAttrs, options);

            return this;
        },

        ////////////
        // events //
        ////////////
        onNumWeekChange: function(model, value, options) {
            this.get(this.isWeight() ? "weeks" : "phases")
                .onNumWeekChange(this, value, options);
        },

        ////////////////
        // validation //
        ////////////////
        validate: function(attrs, options) {
            var errors = [];
            if (this.isWeight() && !this.getWeeks().isValid(options)) {
                errors.push({ attribute: "weeks", error: "There are errors within the weeks data" });
            } else if (this.isCardio()) {
                // TODO implement me
            }

            if (errors.length > 0) {
                return errors;
            }
        },

    }, {
        //////////////////////
        // class properties //
        //////////////////////

        defaults: {
            getWeight: function() {
                return {
                    repsType: "reps",
                    loadEnabled: false,
                    multiEnabled: false,
                    weeks: [],
                    type: "weight",
                };
            },
            getCardio: function() {
                return {
                    weekDone: [],
                    phases: [],
                    effort: { unit: "/10", min: 0, max: 10 },
                    type: "cardio",
                };
            },
        },

        createFromAnimation: function(animation, options) {
            return new this({
                _animation: animation.attributes,
                animatedExercise: animation.id
            }, options);
        },

    });

    return MExercise;
});

